import { render, staticRenderFns } from "./configurationComponent.vue?vue&type=template&id=6959e530"
import script from "./configurationComponent.vue?vue&type=script&lang=js"
export * from "./configurationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports